import { ResizeOperateType, ScaleOperateType, type ILayerInfo, type ILayerProps } from '@/version-types';

/** resize/scale 手柄在未旋转坐标系中的单位方向。 */
const operateTypeMap = {
    [ResizeOperateType.LC]: [-1, 0],
    [ResizeOperateType.RC]: [1, 0],
    [ResizeOperateType.TC]: [0, 1],
    [ResizeOperateType.BC]: [0, -1],
    [ScaleOperateType.LT]: [-1, 1],
    [ScaleOperateType.LB]: [-1, -1],
    [ScaleOperateType.RT]: [1, 1],
    [ScaleOperateType.RB]: [1, -1],
};

/** 获取操作手柄经过图层旋转后的世界方向。 */
export const getDirectionVector = (operateType: ResizeOperateType | ScaleOperateType, angle: number) => {
    const [x1, y1] = operateTypeMap[operateType];
    const arc = ((360 - angle) / 180) * Math.PI;
    let x = x1 * Math.cos(arc) - y1 * Math.sin(arc);
    let y = -(x1 * Math.sin(arc) + y1 * Math.cos(arc));

    if (Math.abs(x) < 1e-10) x = 0;
    if (Math.abs(y) < 1e-10) y = 0;

    return { x, y };
};

/** 把包围盒世界轴增量换算为图层局部 resize 增量。 */
export const getResizeAbsorbOffset = ({
    rotate,
    additionalRectSize,
    isChangeHeight,
    isHorizontal,
}: {
    rotate: number;
    additionalRectSize: number;
    isChangeHeight: boolean;
    isHorizontal: boolean;
}) => {
    if (rotate === 0) return additionalRectSize;

    const arc = ((360 - rotate) / 180) * Math.PI;
    const cosArc = Math.abs(Math.cos(arc));
    const sinArc = Math.abs(Math.sin(arc));

    if (isHorizontal) {
        return Math.round(additionalRectSize / (isChangeHeight ? cosArc : sinArc));
    }
    return Math.round(additionalRectSize / (isChangeHeight ? sinArc : cosArc));
};

/** 把包围盒增量换算为等比 scale 的局部宽高增量。 */
export const getScaleAbsorbOffset = ({
    rotate,
    additionalRectSize,
    isHorizontal,
    mouseOffsetX,
    mouseOffsetY,
    oldLayer,
    oldLayerRect,
}: {
    rotate: number;
    additionalRectSize: number;
    isHorizontal: boolean;
    mouseOffsetX: number;
    mouseOffsetY: number;
    oldLayer: ILayerProps;
    oldLayerRect: ILayerInfo;
}) => {
    if (rotate === 0) {
        const scale = isHorizontal ? mouseOffsetY / oldLayerRect.height : mouseOffsetX / oldLayerRect.width;
        return {
            x: Math.round(oldLayerRect.width * scale),
            y: Math.round(oldLayerRect.height * scale),
        };
    }

    const oldRectSize = isHorizontal ? oldLayerRect.height : oldLayerRect.width;
    const widthScale = oldLayer.width / oldRectSize;
    const heightScale = oldLayer.height / oldRectSize;
    const newRectSize = oldRectSize + additionalRectSize;

    return {
        x: Math.round(widthScale * newRectSize - oldLayer.width),
        y: Math.round(heightScale * newRectSize - oldLayer.height),
    };
};
